import React from "react";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FilterListIcon from '@mui/icons-material/FilterList';
import IntervalPicker from '../IntervalPicker';
import { useDispatch, useSelector } from "react-redux";
import { setShowPicker } from "../../features/settingSlice";

function Handler({ monthsInterval, seeTag, setSeeTag, intervalFilter, setIntervalFilter }) {
  const dispatch = useDispatch();
  const showPicker = useSelector((user) => user.settings.showPicker);

  return (
    <div className="handler">
      <div className="handleDate" onClick={() => {
        if (monthsInterval)
          dispatch(setShowPicker(true));
      }}>
        <div className="icon">
          <CalendarTodayIcon />
        </div>
        <p className="label">{intervalFilter.label}</p>
      </div>
      <div className="handleFilter" onClick={() => setSeeTag(!seeTag)}>
        <div className="icon">
          <p className="label" style={seeTag ? {color: '#000'} : null}>Filtra movimenti</p><FilterListIcon style={seeTag ? {color: '#000'} : null}/>
        </div>
      </div>
      {showPicker && <IntervalPicker monthsInterval={monthsInterval} onSelect={(newIntervalFilter) => {
        setIntervalFilter(newIntervalFilter);
        dispatch(setShowPicker(false));
      }} />}
    </div>
  );
}

export default Handler;
